import styled from '@emotion/styled';
import { css } from '@emotion/react';
import typography from 'storybookConfig/mixins/typography';
import materialSymbol from 'storybookConfig/mixins/materialSymbol';

interface InputChipProps {
  selected?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}

const getColor = ({
  disabled,
  selected,
  theme,
}: {
  disabled?: boolean;
  selected?: boolean;
  theme: any;
}) => {
  if (disabled) return theme.color.bodyTextDisabled;
  if (selected) return theme.color.bodyTextPrimary;
  return theme.color.bodyTextSecondary;
};

const ChipButton = styled.button<InputChipProps>`
  background-color: transparent;
  border: 1px solid;
  border-radius: 6px;
  padding: 8px 12px 8px 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  color: ${({ selected, theme }) =>
    selected ? theme.color.purple500 : theme.color.bodyTextSecondary};
  border-color: ${({ selected, theme }) =>
    selected ? theme.color.purple500 : theme.color.bodyTextSecondary};

  &:hover {
    background-color: ${({ selected, theme }) =>
      selected ? theme.color.gray100 : theme.color.gray100};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}

  ${({ selected }) =>
    selected ? typography('Chips/Chip Text Large') : typography('Chips/Chip Text Large Disabled')};

  ${({ selected, disabled, theme }) =>
    materialSymbol({
      name: selected ? 'cancel' : 'add_circle',
      position: 'after',
      color: getColor({ disabled, selected, theme }),
      size: '20px',
    })}
`;

const InputChip = ({ children, selected, disabled, onClick }: InputChipProps) => (
  <ChipButton
    type="button"
    onClick={disabled ? undefined : onClick}
    selected={selected}
    disabled={disabled}
    aria-pressed={selected}
  >
    {children}
  </ChipButton>
);

export default InputChip;
